angular.module( 'acme.view.application.orders.requests.modals.selectResourceType', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.orders.requests.modals.selectResourceType.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var ordersRequestsModalsSelectResourceType = {
        name: 'application.orders.requests.modals.selectResourceType',
        url: '/orders/requests/modals/selectResourceType',
        views: {
          "main": {
            controller: 'OrdersRequestsModalsSelectResourceTypeController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/orders/requests/modals/selectResourceType/selectResourceType.tpl.html'
          }
        },
        data: {
          pageTitle: '    ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(ordersRequestsModalsSelectResourceType);
});
